// extracted by mini-css-extract-plugin
export default {"component":"RerKY","title":"jswKb","text":"BzIbC"};